import Repository from "../Repository";

const resource = "/limits";
export default {
    create(json) {
        console.log(json)
        return Repository.post(`${resource}`, json);
    },
    update(id, json) {
        return Repository.put(`${resource}/${id}`, json);
    }
}